import { render, staticRenderFns } from "./shopCategory.vue?vue&type=template&id=51a0bbb6&scoped=true&"
import script from "./shopCategory.vue?vue&type=script&lang=js&"
export * from "./shopCategory.vue?vue&type=script&lang=js&"
import style0 from "./shopCategory.vue?vue&type=style&index=0&id=51a0bbb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0bbb6",
  null
  
)

export default component.exports